export interface CreateFacilityRoleDto {
  name: string; // Required, max 100 characters
  description?: string | null; // Optional, max 500 characters
  isActive?: boolean; // Default true
  permissionTypeIds?: number[]; // Default empty array
}
